<template>
  <section
    class="component-ddf36607"
    resmed-component-name="promo_fullwidth_text_image_2cta"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
    }"
  >
    <div class="component" v-bind:style="background">
      <div class="embed-responsive embed-responsive-4by3 d-md-none">
        <!-- background img  -->
      </div>

      <div class="container px-xs-sm-2">
        <div class="row align-items-center content">
          <div class="col-md-6 col-xl-5 offset-xl-1">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
            ></eyebrow-icon>
            <h2
              v-html="acf.headline"
              v-bind:class="{ '-has-eyebrow': acf.eyebrow }"
            ></h2>
            <a
              v-for="item in acf.cta"
              v-bind:href="item.cta.href"
              v-bind:target="item.cta.target"
              class="ctaButton icon cta-pill hallow-white right-arrow"
              >{{ item.cta.text }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-ddf36607", // promo_fullwidth_text_image_2cta
  props: ["acf"],
  data() {
    return {
      active: false,
      background: {},
    };
  },
  watch: {
    "$root.mode": {
      handler(val) {
        if (val === "xs" || val === "sm") {
          this.background["background-image"] = this.acf.layout[
            "background-illustration-xs"
          ]
            ? `url(${this.acf.layout["background-illustration-xs"]})`
            : `url(${this.acf.layout["background-illustration"]})`;
        } else {
          this.background[
            "background-image"
          ] = `url(${this.acf.layout["background-illustration"]})`;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-ddf36607 {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.component {
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center top;

  @media (min-width: 768px) {
    background-position: calc(100% + 1rem) center;
    background-size: 57%;
  }

  @media (min-width: 880px) {
    background-size: 52%;
  }

  @media (min-width: 992px) {
    background-position: calc(100% + 3rem) center;
    background-size: 62%;
  }

  @media (min-width: 1090px) {
    background-size: 58%;
  }

  @media (min-width: 1200px) {
    background-position: calc(100% + 1rem) center;
    background-size: 55%;
  }

  @media (min-width: 1300px) {
    background-size: 50%;
  }

  @media (min-width: 1450px) {
    background-size: 45%;
  }

  h2 {
    position: relative;
    margin-bottom: 1.75rem;
    color: $cc-resmed-white;

    &.-has-eyebrow {
      @extend %eyebrow-left;

      &:before {
        background-color: $cc-resmed-white;
      }
    }
  }

  .content {
    padding: 3rem 0 5rem 0;

    @media (min-width: 768px) {
      padding: 5rem 0;
    }

    @media (min-width: 992px) {
      padding: 7rem 0;
    }

    @media (min-width: 1200px) {
      padding: 9rem 0;
    }
  }

  .btn {
    margin-right: 2rem;
    padding-left: 1.825rem;
  }
}
</style>